import { PrimaryButton } from "@graffer-inc/console-design-kit";
import React from "react";
import { useHistory } from "react-router-dom";
import { RBACHidden } from "../../../helpers/rbac/rbac";

import { ServiceProviderR } from "../../../pages/service-provider/routes";
import { SearchMenu } from "./search-menu";

type Props = {
  orgId: string;
  query?: string;
  onSearch: (query: string) => void;
  onClear: () => void;
};

export const MainMenu: React.FC<Props> = ({
  orgId,
  query,
  onSearch,
  onClear,
}) => {
  const history = useHistory();
  return (
    <div className="columns">
      <RBACHidden requirePermissions="proc_management.procedures.search">
        <SearchMenu query={query} onSearch={onSearch} onClear={onClear} />
      </RBACHidden>
      <div className="column has-text-right buttons">
        <RBACHidden requirePermissions="proc_management.procedures.create">
          <PrimaryButton
            text="手続き新規作成"
            onClick={() => {
              history.push(
                ServiceProviderR.ProcManagementCreate.link({ orgId }),
              );
            }}
          />
        </RBACHidden>
      </div>
    </div>
  );
};

export default MainMenu;
